import { render, staticRenderFns } from "./textInputBig.vue?vue&type=template&id=48288dc1&scoped=true&"
import script from "./textInputBig.vue?vue&type=script&lang=js&"
export * from "./textInputBig.vue?vue&type=script&lang=js&"
import style0 from "./textInputBig.vue?vue&type=style&index=0&id=48288dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48288dc1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VProgressLinear,VTextarea})
